import React from 'react'
import { Outlet } from 'react-router'
import { useInitAnalytics } from '@/web-app/hooks/use-init-analytics'

export default function Root() {
  useInitAnalytics()

  // TODO: add back <AppNav/> and <AppNavProvider/> when ready to add navigation back to webapp pages:
  return (
    <div className='fv:h-screen fv:w-screen fv:relative fv:flex fv:flex-col overflow-hidden'>
      <AppContent>
        <Outlet />
      </AppContent>
    </div>
  )
}

interface IAppContentProps {
  children: React.ReactNode
}

const AppContent = React.memo(({ children }: IAppContentProps) => {
  return (
    <div className='fv:flex-1 fv:w-full fv:relative fv:flex fv:flex-col fv:min-h-0 overflow-hidden'>{children}</div>
  )
})
